import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { paths } from '@/routes/paths';

/** Wraps auth pages: an already-authenticated user is bounced to the dashboard. */
export function PublicOnlyRoute({ children }: { children: ReactNode }) {
  const status = useAuthStore((s) => s.status);
  if (status === 'authenticated') return <Navigate to={paths.dashboard} replace />;
  return <>{children}</>;
}
